var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    viewBox: "0 0 36 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53659 0C0.687953 0 0 0.687953 0 1.53659V16.628H0.863339C1.17305 19.0426 3.236 20.9085 5.73476 20.9085C7.51328 20.9085 9.07102 19.9632 9.93293 18.5476C10.7948 19.9632 12.3526 20.9085 14.1311 20.9085C16.6299 20.9085 18.6928 19.0426 19.0025 16.628H20.6581L22.4451 14.2134H36V1.53659C36 0.687953 35.312 0 34.4634 0H1.53659ZM8.12195 15.997C8.12195 17.3154 7.05317 18.3841 5.73476 18.3841C4.41634 18.3841 3.34756 17.3154 3.34756 15.997C3.34756 14.6785 4.41634 13.6098 5.73476 13.6098C7.05317 13.6098 8.12195 14.6785 8.12195 15.997ZM14.1311 18.3841C15.4495 18.3841 16.5183 17.3154 16.5183 15.997C16.5183 14.6785 15.4495 13.6098 14.1311 13.6098C12.8127 13.6098 11.7439 14.6785 11.7439 15.997C11.7439 17.3154 12.8127 18.3841 14.1311 18.3841Z",
    fill: "#555962"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/Trailer.3899ccde862e992d03681996c5514130.svg";
export { ForwardRef as ReactComponent };